<!--
	name: CInt   Version: V3.0   by: coon    publish: 2024/06/17;
	include:

	功能：该组件用于实现整形数输入, 可以通过上下按钮调节
	      可响应 :change事件
	组件调用参数:
		参数名           必要性    值域          说明
		maxln            必须      1-6           最大输入长度

	输出的值:
		$emit("input")    可用 v-model 接收参数值
	外部调用方法:
		无
-->

<template>
	<div style="width:100%; height:100%; position:relative;" id="idInpPan" ref="idInpPan">
		<input ref="idCInp" type="text" style="text-indent:4px; float:left;" @change="IntChange2();" @focus="setLabFocus();" @blur="setLabBlur();">
		<div id="idDec" ref="idDec" class="OPInt DIVNoSelect" style="position:absolute; width:26px; border:1px solid #777777; border-radius:0px 3px 0px 0px; background:url(../static/images/arr1.png); background-size:100% 100%;" @click="IntChange( 1);"></div>
		<div id="idAdd" ref="idAdd" class="OPInt DIVNoSelect" style="position:absolute; width:26px; border:1px solid #777777; border-radius:0px 0px 3px 0px; background:url(../static/images/arr2.png); background-size:100% 100%;" @click="IntChange(-1);"></div>
	</div>
</template>

<script>

export default {
	name: 'CInpInt',
	props:[ 'maxln', 'def', 'change', 'minv', 'maxv', 'lab' ],
	data () {
		return {
			oldV: 0,
		}
	},
	mounted: function(){
		this.oldV = this.def;

		let w1=this.$refs["idInpPan"].clientWidth;
		let h1=this.$refs["idInpPan"].clientHeight;
		this.$refs["idCInp"].style["width"]  = (w1)+"px";
		this.$refs["idCInp"].style["height"] = (h1)+"px";
		this.$refs["idCInp"].setAttribute("maxlength", this.maxln);
		this.$refs["idCInp"].value = this.oldV;

		this.$refs["idDec"].style["left"]   = (w1-26+6)+"px";
		this.$refs["idDec"].style["top"]    = (0)+"px";
		this.$refs["idDec"].style["height"] = (h1/2+2)+"px";

		this.$refs["idAdd"].style["left"]   = (w1-26+6)+"px";
		this.$refs["idAdd"].style["top"]    = (h1/2+2)+"px";
		this.$refs["idAdd"].style["height"] = (h1/2+2)+"px";
	},
	computed:{

	},
	methods:{
		IntChange: function( v ){
			let v2 = this.oldV + v;
			if( this.isNumber(this.minv) && v2 < this.minv ) v2 = this.minv;
			if( this.isNumber(this.maxv) && this.maxv < v2 ) v2 = this.maxv;

			this.$refs["idCInp"].value = v2;

			this.$emit("input", v2 );
			if( this.change )
			{
				this.change( v2, this.oldV );
			}
			this.oldV = v2;
		},
		IntChange2: function(){
			let v2 = parseInt(this.$refs["idCInp"].value);
			if( this.isNumber(this.minv) && v2 < this.minv ) { v2 = this.minv; this.$refs["idCInp"].value = v2; }
			if( this.isNumber(this.maxv) && this.maxv < v2 ) { v2 = this.maxv; this.$refs["idCInp"].value = v2; }

			this.$emit("input", v2 );
			if( this.change && (this.oldV != v2) )
			{
				this.change( v2, this.oldV );
			}
			this.oldV = v2;
		},
		setLabFocus: function(){
			if( this.$parent.setInputLab && this.lab ) this.$parent.setInputLab( this.lab, 1 );
		},
		setLabBlur: function(){
			if( this.$parent.setInputLab && this.lab ) this.$parent.setInputLab( this.lab, 0 );
		},
	}
}

</script>

<style scoped>

.OPInt{ cursor:pointer; }
.OPInt:hover{ opacity:0.5; }

</style>



// WEBPACK FOOTER //
// cinpint.vue?12a85215